import React from "react";

import { useNavigate } from "react-router-dom";

import "./pages/Requests/Requests.css";

import uuid from "react-uuid";
import { format, parse } from "date-fns";

import Interval from "./Interval";

function RequestsField({ filteredRequests, status, substatus }) {
  const navigate = useNavigate();

  function formatDate(date) {
    const today = new Date();
    const tomorrow = new Date();
    const yesterday = new Date();
    tomorrow.setDate(today.getDate() + 1);
    yesterday.setDate(today.getDate() - 1);

    if (date.toDateString() === today.toDateString()) {
      return "Сегодня";
    } else if (date.toDateString() === tomorrow.toDateString()) {
      return "Завтра";
    } else if (date.toDateString() === yesterday.toDateString()) {
      return "Вчера";
    } else {
      const options = { day: "numeric", month: "short" };
      return date.toLocaleDateString("ru-RU", options);
    }
  }

  const theme = localStorage.getItem("theme");

  const requests = [...filteredRequests]
    .filter(
      (request) => request.status === status && request.substatus === substatus,
    )
    .map((request) => {
      return (
        <div key={uuid()} className="requestPosition">
          <div className="requestTicket">
            <div
              onClick={() => {
                navigate("confirm", { state: { request: request } });
              }}
              className="requestHeader"
            >
              {request.substatus === "На проверке" ? (
                <React.Fragment>
                  <span className="requestNomenclature">
                    {request.nomenclature}
                  </span>
                  {request.markArticle ? (
                    <span className="requestArticle">
                      арт. {request.markArticle}
                    </span>
                  ) : null}
                </React.Fragment>
              ) : null}

              <span className="requestAddress">{request.address}</span>
              <span className="counterpart">{request.counterpart}</span>
              <hr className="requestLine" />

              <div className="timeAndCapacityInfo">
                <div className="infoTimeAndCapacityBlock">
                  <span className="capacityTitle">Дата</span>
                  <span className="capacityValue">
                    {formatDate(parse(request.date, "dd.MM.yy", new Date()))}
                  </span>
                </div>
                <div className="infoTimeAndCapacityBlock">
                  <span className="capacityTitle">Время</span>

                  {request.dateChanged ? (
                    <div className={"changedValueFrame"}>
                      <span className="capacityTitleRed">{request.time}</span>
                      <svg
                        style={{ marginTop: "1.2px" }}
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                      >
                        <path
                          d="M7.34713 3.66512H6.65504C6.59173 3.66512 6.53993 3.71535 6.53993 3.77675V7.61814C6.53993 7.65442 6.5572 7.68791 6.58741 7.70884L8.96585 9.39302C9.01765 9.4293 9.08959 9.41954 9.127 9.3693L9.53852 8.82512C9.57736 8.77349 9.56585 8.70372 9.51405 8.66884L7.46224 7.23023V3.77675C7.46224 3.71535 7.41044 3.66512 7.34713 3.66512ZM10.5097 4.71442L12.7659 5.24884C12.8378 5.26558 12.9083 5.21256 12.9083 5.1414L12.9198 2.88791C12.9198 2.79442 12.809 2.7414 12.7342 2.8L10.4666 4.51768C10.4494 4.53053 10.4364 4.54782 10.4289 4.56755C10.4215 4.58728 10.4199 4.60865 10.4244 4.6292C10.4289 4.64975 10.4393 4.66865 10.4544 4.68373C10.4695 4.6988 10.4887 4.70944 10.5097 4.71442ZM12.9227 8.91581L12.1069 8.64372C12.0784 8.63427 12.0473 8.63598 12.0201 8.6485C11.993 8.66101 11.972 8.68334 11.9616 8.7107C11.9342 8.78186 11.9054 8.85163 11.8752 8.9214C11.6191 9.50884 11.2522 10.0377 10.7831 10.4912C10.3193 10.9424 9.76954 11.3021 9.16441 11.5502C8.53754 11.8073 7.8637 11.9392 7.1831 11.9381C6.49533 11.9381 5.82913 11.8084 5.20179 11.5502C4.59666 11.3021 4.04693 10.9424 3.58307 10.4912C3.11544 10.0377 2.74853 9.50884 2.49098 8.9214C2.2274 8.31314 2.09236 7.65978 2.09385 7C2.09385 6.33302 2.22767 5.68558 2.49386 5.07721C2.74997 4.48977 3.11688 3.96093 3.58595 3.50744C4.04981 3.05621 4.59954 2.69655 5.20467 2.44837C5.82913 2.19023 6.49676 2.06047 7.18454 2.06047C7.87231 2.06047 8.53851 2.19023 9.16585 2.44837C9.77098 2.69655 10.3207 3.05621 10.7846 3.50744C10.9313 3.65116 11.0695 3.80047 11.1961 3.95814L12.0565 3.30512C10.9241 1.9014 9.16153 0.998606 7.18166 1C3.73415 1.0014 0.965787 3.71675 1.00032 7.0614C1.03485 10.3474 3.79027 13 7.18454 13C9.85363 13 12.127 11.3591 12.9932 9.06093C13.0148 9.00233 12.9831 8.93674 12.9227 8.91581Z"
                          fill={theme === "dark" ? "#FF8B86" : "#F54941"}
                          stroke={theme === "dark" ? "#FF8B86" : "#F54941"}
                          strokeWidth="0.2"
                        />
                      </svg>
                    </div>
                  ) : (
                    <span className="capacityValue">{request.time}</span>
                  )}
                </div>
                <div className="infoTimeAndCapacityBlock">
                  <span className="capacityTitle">Объём</span>
                  {request.capacityChanged ? (
                    <div className={"changedValueFrame"}>
                      <span className="capacityTitleRed">
                        {request.capacity}
                      </span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ marginTop: "2px" }}
                        width="15"
                        height="12"
                        viewBox="0 0 15 12"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_709_11354)">
                          <path
                            d="M7.56665 1.29999H13.5667"
                            stroke={theme === "dark" ? "#FF8B86" : "#F54941"}
                            strokeWidth="1.2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M1.66666 8.5L4.16666 11"
                            stroke={theme === "dark" ? "#FF8B86" : "#F54941"}
                            strokeWidth="1.2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M4.16666 1L4.16666 11"
                            stroke={theme === "dark" ? "#FF8B86" : "#F54941"}
                            strokeWidth="1.2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M7.56665 4.29999H12.3667"
                            stroke={theme === "dark" ? "#FF8B86" : "#F54941"}
                            strokeWidth="1.2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M7.56665 7.29999H11.1667"
                            stroke={theme === "dark" ? "#FF8B86" : "#F54941"}
                            strokeWidth="1.2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M7.56665 10.3H9.96665"
                            stroke={theme === "dark" ? "#FF8B86" : "#F54941"}
                            strokeWidth="1.2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_709_11354">
                            <rect
                              width="14"
                              height="12"
                              fill="white"
                              transform="translate(0.666656)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                  ) : (
                    <span className="capacityValue">{request.capacity}</span>
                  )}
                </div>
                {/* <div className='infoTimeAndCapacityBlock'>
                                <span className='capacityTitle'>Приём</span>
                                <span className='capacityValue'>{request.acceptance_method === 'Свая/Самослив' ? 'Самослив' : request.acceptance_method}</span>
                            </div> */}
              </div>
              {request.status === "Завершена" ? null : (
                <>
                  <hr className="requestLine" />
                  <Interval
                    interval={request.interval}
                    ticketIndex={request.number}
                    requestUID={request.order_uid}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      );
    });

  return (
    <>
      {requests.length === 0 ? (
        <h1 className="emptyHeader">Нет заявок, ожидающих подтверждение</h1>
      ) : (
        requests
      )}
    </>
  );
}

export default RequestsField;
